import { Voyage } from "../../types/Voyage";

const GetVoyageOptions = (voyages: Voyage[]) => {
  const voyageOptions = [];

  
  if (!voyages || voyages.length === 0) {
      return voyageOptions
  }

  voyages.map((voyage: Voyage) => { 
    voyageOptions.push({
      value: voyage['@id'],
      label: voyage.name,
    })
  })

  return voyageOptions;
}

export default GetVoyageOptions;